import React from 'react';
import styles from "./App.module.css";
import {PrimeReactProvider} from "primereact/api";

import "primereact/resources/themes/lara-light-amber/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import StepperComponent from "./component/StepperComponent";


function App() {
    return (
        <>
            <PrimeReactProvider value={{}}>
                <div className={`${styles.main}`}>
                    <StepperComponent />
                </div>
            </PrimeReactProvider>
        </>
    );
}

export default App;
